import { defineStore } from "pinia";
import { login, veriFication, logout, ResendVeriFication, getAdminProfile} from "@/api/authApi";

export const useAuthStore = defineStore("auth", {
  state: () => ({
    user: JSON.parse(localStorage.getItem('user') || '{}'),
    token: localStorage.getItem('BearerToken') || '',
  }),
  getters: {
    isSuperAdmin: (state) => state.user?.role === 'super',
    isAdmin: (state) => state.user?.role === 'admin',
    isEditor: (state) => state.user?.role === 'editor',
    isReader: (state) => state.user?.role === 'reader',
    userRole: (state) => state.user?.role || 'reader',
    // Helper to check if user has required role
    hasRole: (state) => (requiredRoles: string[]) => {
      return requiredRoles.includes(state.user?.role);
    },
    // Check if user can access specific permission level
    canView: (state) => state.user?.role && ['super', 'admin', 'editor', 'reader'].includes(state.user.role),
    canEdit: (state) => state.user?.role && ['super', 'admin', 'editor'].includes(state.user.role),
    canDelete: (state) => state.user?.role && ['super', 'admin'].includes(state.user.role),
    canManageSystem: (state) => state.user?.role && ['super', 'admin'].includes(state.user.role),
  },
  actions: {
    async loginUser(credentials: { email: string; password: string, token: any }) {
      return new Promise(async (resolve, reject) => {
        try {
          const userDetail = {
            email: credentials.email,
            password: credentials.password,
            'captcha_token': credentials.token
          }
          const response = await login(userDetail);
          
          if (response.status === 200 || String(response.status) === "success")  {
            // Store user data in localStorage
            if (response.data?.user) {
              localStorage.setItem('user', JSON.stringify(response.data.user));
              this.user = response.data.user;
            }
            if (response.data?.token) {
              localStorage.setItem('BearerToken', response.data.token);
              this.token = response.data.token;
            }
            resolve(response);
          } else {
            reject(new Error("Invalid login attempt"));
          }
        } catch (error) {
          console.error("Login failed:", error);
          reject(new Error('Login failed'));
        }
      })
    },
    async userVerification(userDta:{ id: any, verified_code: any}) {
      console.log("userVerification");
      return new Promise(async (resolve, reject) => {
        try {
          const  data  = await veriFication(userDta);
          console.log(data,"verify");
          
          if (data.status === 200 || String(data.status) === "success") { 
            resolve(data);
          }
          else {
            reject(new Error("Some thing went wrong!"));
          }
        } catch (error) {
          console.error("Registration failed:", error);
          reject(new Error('Registration failed'));
        }
      })
    },
    async resendVerification(id:{id: any}) {
      return new Promise(async (resolve, reject) => {
        try {
          const { data } = await ResendVeriFication(id);
          if ((data.status === 200 || String(data.status) === "success")) { 
            resolve(data);
          }
          else {
            reject(new Error("Some thing went wrong!"));
          }
        } catch (error) {
          console.error("Resend veriFication failed:", error);
          reject(new Error('Resend veriFication failed'));

        }
      })
    },
     async logoutUser() {
      try {
        await logout();
        // Clear localStorage
        localStorage.removeItem('user');
        localStorage.removeItem('BearerToken');
        this.user = {};
        this.token = '';
      } catch (error) {
        console.error("Logout failed:", error);
      }
    },
      async initAuth() {
      if (!this.token) return;

      try {
        const { data } = await getAdminProfile(); // Fetch user info using saved token
        if (data?.user) {
          this.user = data.user;
          localStorage.setItem("user", JSON.stringify(data.user));
        }
      } catch (error) {
        console.warn("Token invalid or user fetch failed:", error);
        // Clear auth if token is invalid
        this.logoutUser();
      }
    },
  },
});
